<template>
  <div :class="styleClasses.card">
    <div :class="styleClasses.card_header">
      <span class="me-2">{{ formatTimestamp(reservation.datetime || reservation.created_at, 'MM/DD HH:mm') }}</span>
      <span>
        {{
        reservation.foreign_type === 21
        ? reservation.course?.label
        : reservation.route === 3
        ? '乗車'
        : reservation.user?.username || reservation.demandSchedule?.demandArea?.label ||'--'
        }}
      </span>
    </div>
    <div :class="styleClasses.card_body">
      <div :class="styleClasses.card_body_content">
        <div :class="styleClasses.reservation">
          <div>
            <!-- memo -->
            <div :class="styleClasses.item" v-if="reservation.memo">
              <div>
                <i class="fa-solid fa-pen" />
                <span class="ms-2">メモ</span>
              </div>
              <div>{{ reservation.memo.memo }}</div>
            </div>

            <!-- pickup -->
            <div :class="styleClasses.item">
              <div>
                <i class="fa-solid fa-location-dot" />
                <span class="ms-2">乗車地点</span>
              </div>
              <div>{{ reservation.p_address?.replace('日本、', '') }}<br>{{ reservation.p_title }}</div>
            </div>

            <!-- waypoints -->
            <div :class="styleClasses.item" v-for="(waypoint, i) in reservation.waypoints" :key="waypoint.id">
              <div>
                <i class="fa-solid fa-location-dot" />
                <span class="ms-2">経由地点 {{ i + 1 }}</span>
              </div>
              <div>{{ waypoint.address?.replace('日本、', '') }}<br>{{ waypoint.title }}</div>
            </div>

            <!-- destination -->
            <div v-if="reservation.d_address || reservation.d_title" :class="styleClasses.item">
              <div>
                <i class="fa-solid fa-location-dot" />
                <span class="ms-2">降車地点</span>
              </div>
              <div>{{ reservation.d_address?.replace('日本、', '') }}<br>{{ reservation.d_title }}</div>
            </div>

            <!-- destination -->
            <div v-if="reservation.e_price" :class="styleClasses.item">
              <div>
                <i class="fa-solid fa-location-dot" />
                <span class="ms-2">料金</span>
              </div>
              <div>{{ reservation.e_price.toLocaleString() }}円</div>
            </div>

            <!-- revision -->
            <div :class="styleClasses.item">
              <div>
                <i class="fa-solid fa-clock-rotate-left" />
                <span class="ms-2">乗車履歴</span>
              </div>
              <ul :class="styleClasses.revisions">
                <li v-if="!reservation.order.revisions?.length">乗降車時刻の記録がありません。</li>
                <li v-for="revision in reservation.order.revisions" :key="revision.id">
                  <span class="me-2">{{ formatTimestamp(revision.created_at, 'HH:mm') }}</span>
                  <span>{{ revisionLabel(revision.to_flag) }}</span>
                </li>
              </ul>
            </div>

            <!-- orderResult -->
            <div :class="styleClasses.item" v-if="reservation.foreign_type !== 31">
              <div>
                <i class="fa-solid fa-check" />
                <span class="ms-2">乗車データ入力</span>
              </div>
              <div class="d-flex align-items-center">
                <ul v-if="reservation.order.orderResult">
                  <li>確定料金： {{ addComma(Math.ceil(this.discountedOrderResultPrice(reservation) || 0)) }}円 {{ getDiscountedType(reservation) }}</li>
                  <li>乗車人数： {{ reservation.order.orderResult.passenger_count || '--' }}人</li>
                </ul>
                <div v-else>＊未入力</div>
                <div class="ms-auto me-3">
                  <div :class="styleClasses.buttons">
                    <button @click="openOrderResultModal(reservation)" :class="styleClasses.green">{{ reservation.order.orderResult ? '編集' : '登録' }}する</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-2" :class="styleClasses.buttons">
              <router-link
                :to="`/chat/${reservation.id}/operator`">
                <button :class="[styleClasses.gray]">
                  <i class="fa-regular fa-comments me-2"/>オペレーターとチャット
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'order  ',
  mixins: [cf],
  props: {
    reservation: Object,
    styleClasses: Object,
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapState(['user', 'helper', 'modal']),
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },
    getDiscountedType(reservation) {
      const orderResult = reservation?.order?.orderResult;
      let label = '';
      if (!orderResult?.price) return label;

      if (orderResult.ticket_id) {
        label += 'チケット利用';
      }
      if (orderResult.is_discounted) {
        label += orderResult.ticket_id ? '・身体障害者割引' : '身体障害者割引';
      }
      if (label) return `(${label})`;
      return '';
    },
    discountedOrderResultPrice(reservation) {
      const orderResult = reservation.order?.orderResult;
      if (!orderResult?.price || orderResult.ticket_id) return 0;
      if (orderResult.is_discounted) return orderResult.price * 0.9; // 身体障害者割引は10%OFF
      return orderResult.price;
    },
    revisionLabel(flag) {
      if (!this.helper.master.orders) return '不明';
      const targetFlag = this.helper.master.orders.flags.find((f) => f.value === flag);
      return targetFlag ? targetFlag.label : '不明';
    },
    openOrderResultModal(rsv) {
      let data;
      if (rsv?.order?.orderResult) {
        data = {
          id: rsv.order.orderResult.id,
          orderId: rsv.order.id,
          price: rsv.order.orderResult.price,
          capacity: rsv.order.orderResult.passenger_count,
          ticketId: rsv.order.orderResult.ticket_id,
          isDiscounted: rsv.order.orderResult.is_discounted,
          showOrderResultForm: true,
          showThanksMessage: false,
        };
      } else {
        const price = rsv.order?.reservation?.e_price || null;
        const capacity = rsv.order?.vehicle?.capacity || 1;
        data = {
          orderId: rsv.order.id,
          price: this.user.role.role === 13 ? price : null,
          capacity,
          showOrderResultForm: true,
          showThanksMessage: false,
        };
      }

      const args = {
        modalName: 'OrderResult',
        modalTitle: '配車結果',
        data,
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },
  },
};
</script>
